import React from "react";
import Button from "@material-ui/core/Button";
import { languages } from "../constants/languages";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withTheme } from "@material-ui/core/styles";
import StarIcon from "@material-ui/icons/Star";
import green from "@material-ui/core/colors/green";

class NewTournamentDialog extends React.Component {
  render() {
    return (
      <Snackbar
        style={{ maxWidth: 350 }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.props.open}
        onClose={this.props.handleClose}
      >
        <SnackbarContent
          style={{ backgroundColor: green[600] }}
          aria-describedby="message-id"
          message={
            <div id="message-id">
              <div style={{ width: 280, textAlign: "center" }}>
                <StarIcon style={{ height: 40 }} />
              </div>
              {languages.createTournament.createSuccess +
                " " +
                languages.formatString(
                  languages.createTournament.createSuccessDescription,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                ) +
                " " +
                languages.createTournament.createSuccessDescription2}
            </div>
          }
          action={[
            <Button
              key="0"
              style={{ color: "white" }}
              variant="text"
              color="default"
              onClick={() => {
                this.props.handleDrawerOpen();
                this.props.handleClose();
              }}
            >
              {languages.createTournament.watchExplanation}
            </Button>
          ]}
        />
      </Snackbar>
    );
  }
}

export default withTheme(NewTournamentDialog);
